import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';

import css from './CreatorsPage.module.css';

const involveImg = '/static/images/involve-img.avif';

const listItem = (titleMsgId, textMsgId) => (
  <li className={css.involveListItem}>
    <h3 className={css.involveListItemTitle}>
      <FormattedMessage id={titleMsgId} />
    </h3>
    <p className={css.involveListItemText}>
      <FormattedMessage id={textMsgId} />
    </p>
  </li>
);

const SectionInvolve = () => {
  return (
    <div className={css.sectionInvolve}>
      <h2 className={css.involveTitle}>
        <FormattedMessage id="AudiencePage.involveTitle" />
      </h2>
      <div className={css.involveContent}>
        <img className={css.involveImg} alt="involve" src={involveImg} />
        <ul className={css.involveList}>
          {listItem('AudiencePage.involveFirstLineTitle', 'AudiencePage.involveFirstLineText')}
          {listItem('AudiencePage.involveSecondLineTitle', 'AudiencePage.involveSecondLineText')}
          {listItem('AudiencePage.involveThirdLineTitle', 'AudiencePage.involveThirdLineText')}
          {listItem('AudiencePage.involveForthLineTitle', 'AudiencePage.involveForthLineText')}
        </ul>
      </div>
    </div>
  );
};

export default SectionInvolve;
